import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import React, { Fragment } from "react";
import CouponItem from "./item";
import "./styles.scss";
// import Marquee from "react-fast-marquee";
import { Autoplay } from "swiper";

const Coupons = (props) => {
  const { items } = props;
  if (items?.length <= 0) {
    return <></>;
  }
  // console.log(items);
  return (
    <div className="coupons">
      <Swiper
        loop={true}
        freeMode
        slidesPerView={"auto"}
        spaceBetween={0}
        modules={[Autoplay]}
        simulateTouch={true}
        autoplay={{
          delay: 5500,
          disableOnInteraction: false,
        }}
      >
        {items?.map((item, index) =>
          item?.show === "true" ? (
            <SwiperSlide key={index} style={{ width: "auto" }}>
              <CouponItem item={item} />
            </SwiperSlide>
          ) : (
            <Fragment key={index} />
          )
        )}
      </Swiper>
    </div>
  );
};
export default Coupons;
